import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { formatConfidence, formatLift, formatSupport, getStrength, getStrengthColor, getStrengthThumb } from "../../common/common";
import { useDispatch, useSelector } from "react-redux";
import CustomerPopupWithOrder from "../DashboardContent/HistoryAnalysis/customerPopupwithOrder";
import { setAntecedentInfo, setIsProductPage } from "../../../store";
import { useNavigate } from "react-router-dom";
import ProductPage from "../DashboardContent/HistoryAnalysis/productPage/productpage";


const FavoriteCombinations = ({
    analysis_details_id,
    order_details_id,
    switchTab,
    supportFilter,
    sortBy,
    searchQueryForItemsets,
    selectedCombo,
    setCountItemSet
}) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const currentAnalysisData = useSelector((state) => state.analysisData.currentAnalysisData);
    const [mainFavoriteCombinationsResponse,setMainFavoriteCombinationResponse] = useState([]);
    const [favoriteCombinationsResponse, setFavoriteCombinationResponse] = useState([]);
    const [analysisResultFavoriteList, setAnalysisResultFavoriteList] = useState({});
    const [showLoading, setShowLoading] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [productList, setProductList] = useState([]);
    const [sku, setSku] = useState([]);
    const [isBoth, setIsBoth] = useState({
        antecedent: false,
        consequent: false,
        all: false,
    });
    const [isClickOnSku,setIsClickOnSku] = useState(false);


    const getFavoriteCombinationList = async () => {
        try {
            setShowLoading(true);
            const response = await axios.get(
                `${process.env.REACT_APP_API_END_POINT}/data-analysis/list-favorite-combination?analysis_details_id=${analysis_details_id}&order_details_id=${order_details_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            const newResponseWithModify = response.data.data.map((data) => {
                let antecedentSkus = [];
                let consequentSkus = [];

                data.antecedents.forEach((sku) => {
                    antecedentSkus.push(sku.sku);
                });

                data.consequent.forEach((sku) => {
                    consequentSkus.push(sku.sku);
                });
                // {
                //     console.log(currentAnalysisData,"currentAnalysisData")
                // }
                const modifiedData = {
                    ...data,
                    totalPurchasedTogether: Math.round(
                        // data.support * currentAnalysisData?.totalOrder
                        data.support * currentAnalysisData.totalOrder

                    ),
                    antecedentPurchasedTogether: Math.round(
                        data.antecedent_support * currentAnalysisData.totalOrder
                    ),
                    consequnetPurchasedTogether: Math.round(
                        data.consequent_support * currentAnalysisData.totalOrder
                    ),
                    antecedentSkus,
                    consequentSkus,
                    allSkus: [...antecedentSkus, ...consequentSkus],
                };

                return modifiedData;
            });

            // const filterAnalysisDataWithSupport = newResponseWithModify.filter(
            //     (result) => {
            //       let support = formatSupport(result.support);
          
            //       let totalPurchasedTogether = Math.round(
            //           supportFilter/100 * currentAnalysisData?.totalOrder
            //         )
          
            //       // console.log(support,"support",result.support,totalPurchasedTogether,result.totalPurchasedTogether)
            //       return result.totalPurchasedTogether >= totalPurchasedTogether;
            //       // return support >= supportFilter;
          
            //     }
            //   );

            setFavoriteCombinationResponse(newResponseWithModify)
            setMainFavoriteCombinationResponse(newResponseWithModify)

            toast.success("Favorite combinations fetched");
            // Use `response.data` here as needed
        } catch (error) {
            if (error.response.data?.detail?.isExpireToken) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                navigate("/login")
            }
            toast.error(error.response?.data?.message || error.message);
            
        } finally {
            setShowLoading(false)
        }
    }

    const handleToggleFavorite = async (id, isFavorite = false) => {
        const newStatus = await markAsFavorite(id, !isFavorite);
        setAnalysisResultFavoriteList((prev) => {
            return {
                ...prev,
                [id]: newStatus
            }
        });
    };

    const handleView = (asku, csku, allsku, isSignle) => {
        setModalOpen(true);
        setSku({
          antecedentSKU: asku,
          consequentSKU: csku,
          allSku: allsku,
        });
    };

    const markAsFavorite = async (analysis_result_id, isFavorite = true) => {
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_END_POINT}/data-analysis/analysis-result-favorite`,
                null, // no body for PUT query param-based request
                {
                    params: {
                        analysis_result_id,
                        isFavorite,
                    },
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            toast.success("Favorite updated")
            return isFavorite;
            //   console.log("Favorite updated:", response.data);
            //   return response.data;
        } catch (error) {
            if (error.response.data?.detail?.isExpireToken) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                navigate("/login")
            }
            toast.error(error.response?.data || error.message)
            return isFavorite; // fallback: unchanged
            //   console.error("Error updating favorite:", error.response?.data || error.message);
            //   throw error;
        }
    };


    useEffect(()=>{

        let filterAnalysisDataWithSupport = mainFavoriteCombinationsResponse.filter(
            (result) => {
      
              let totalPurchasedTogether = Math.round(
                  supportFilter/100 * currentAnalysisData?.totalOrder
                )
              return result.totalPurchasedTogether >= totalPurchasedTogether;
            }
        );

        // console.log(mainFavoriteCombinationsResponse.length,supportFilter,"supportFilter")


        const query = searchQueryForItemsets.toLowerCase().trim();

        // 1. Search filter
        if (query) {
            filterAnalysisDataWithSupport = filterAnalysisDataWithSupport.filter((item) => {
            const items = [...item.antecedents];
            const isSKU = items.some((sku) => sku?.sku.toLowerCase() === query);
            const isProductName = items.some((sku) =>
            sku?.product_title?.toLowerCase().includes(query)
            );
            return isSKU || isProductName;
            });
        }

        let itemSetCounter = {
            item_set_1: 0,
            item_set_2: 0,
            item_set_3: 0,
            item_set_4: 0,
            item_set_all: 0,
          };
          filterAnalysisDataWithSupport.map((result) => {
            const antecedentsLength = result.antecedents.length;
            // Count logic
            if (antecedentsLength === 1) itemSetCounter.item_set_1++;
            if (antecedentsLength === 2) itemSetCounter.item_set_2++;
            if (antecedentsLength === 3) itemSetCounter.item_set_3++;
            if (antecedentsLength === 4) itemSetCounter.item_set_4++;
            if (true) itemSetCounter.item_set_all++;
          });
         
          if(switchTab === 3){
            setCountItemSet(itemSetCounter);
          }


        filterAnalysisDataWithSupport = filterAnalysisDataWithSupport.filter((result) => {
            let antecedentsLength = result.antecedents.length;
            if (selectedCombo !== 0 && selectedCombo === antecedentsLength) {
              return true;
            }
            if (selectedCombo === 0) {
              return true;
            }
        });

        let newFilter = [...filterAnalysisDataWithSupport];

        // 2. Sort correctly for all cases
        switch (sortBy) {
        case "hl": // High lift
            newFilter = [...newFilter].sort(
            (a, b) => Number(b.lift) - Number(a.lift)
            );
            break;
        case "ll": // Low lift
            newFilter = [...newFilter].sort(
            (a, b) => Number(a.lift) - Number(b.lift)
            );
            break;
        case "hs": // High days
            newFilter = [...newFilter].sort((a, b) => b.support - a.support);
            break;
        case "ls": // Low days
            newFilter = [...newFilter].sort((a, b) => a.support - b.support);
            break;
        case "hc": // High days
            newFilter = [...newFilter].sort((a, b) => b.confidence - a.confidence);
            break;
        case "lc": // Low days
            newFilter = [...newFilter].sort((a, b) => a.confidence - b.confidence);
            break;
        case "strong":
            newFilter = [...newFilter].sort((a, b) => {
            const MIN_SUPPORT_PCT = 0.01;
            const MIN_CONFIDENCE_PCT = 50.0;

            const supportA = a.support * 100;
            const confidenceA = a.confidence * 100;
            const liftA = a.lift;
            const isStrongA =
                supportA >= MIN_SUPPORT_PCT &&
                confidenceA >= MIN_CONFIDENCE_PCT &&
                liftA > 1.0;

            const supportB = b.support * 100;
            const confidenceB = b.confidence * 100;
            const liftB = b.lift;
            const isStrongB =
                supportB >= MIN_SUPPORT_PCT &&
                confidenceB >= MIN_CONFIDENCE_PCT &&
                liftB > 1.0;

            if (isStrongA && !isStrongB) return -1; // A comes first
            if (!isStrongA && isStrongB) return 1; // B comes first
            return 0; // No preference if both same
            });
            break;
        case "weak":
            newFilter = [...newFilter].sort((a, b) => {
            const MIN_SUPPORT_PCT = 0.01;
            const MIN_CONFIDENCE_PCT = 50.0;

            const supportA = a.support * 100;
            const confidenceA = a.confidence * 100;
            const liftA = a.lift;
            const isStrongA =
                supportA >= MIN_SUPPORT_PCT &&
                confidenceA >= MIN_CONFIDENCE_PCT &&
                liftA > 1.0;

            const supportB = b.support * 100;
            const confidenceB = b.confidence * 100;
            const liftB = b.lift;
            const isStrongB =
                supportB >= MIN_SUPPORT_PCT &&
                confidenceB >= MIN_CONFIDENCE_PCT &&
                liftB > 1.0;

            if (!isStrongA && isStrongB) return -1; // A is weak, comes first
            if (isStrongA && !isStrongB) return 1; // B is weak, comes first
            return 0; // Both same strength
            });
            break;
        default:
            break;
        }

        setFavoriteCombinationResponse(newFilter)

    },[supportFilter,sortBy,mainFavoriteCombinationsResponse,searchQueryForItemsets,selectedCombo])

    useEffect(() => {
        if(switchTab === 3){
            getFavoriteCombinationList()
        }
    }, [switchTab])

    if (showLoading) {
        return <div className="flex justify-center py-10">
            <div className="w-8 h-8 border-4 border-blue-300 border-t-transparent rounded-full animate-spin"></div>
        </div>
    }


    return (
        <>
            <div className="space-y-6">
                {
                   !isClickOnSku && favoriteCombinationsResponse.length > 0 &&
                    favoriteCombinationsResponse.map((result) => {
                        let isFavorite = analysisResultFavoriteList[result._id] == undefined ?
                            result?.isFavorite ?
                                result?.isFavorite
                                : false
                            : analysisResultFavoriteList[result._id]
                        return <section className="rounded-lg shadow-sm">
                            <div className="mb-10 bg-white border">
                                <div class={`h-12 ${getStrength(result) === "Strong"
                                        ? "bg-powder-lavender-mint"
                                        : "bg-soft-to-deep-red"
                                    }   rounded-t-lg flex items-center justify-between px-6`}>
                                    <div className="flex items-center gap-3">
                                        {/* Strength Badge */}
                                        <span
                                            className={`px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1
                                        ${getStrength(result) === "Strong"
                                                    ? "bg-[#dcfce7]"
                                                    : "bg-[#fee2e2]"
                                                }
                                        ${getStrengthColor(result)}
                                        `}
                                        >
                                            <i className={getStrengthThumb(result)}></i>
                                            {getStrength(result)}
                                        </span>
                                        {/* Favorite Icon */}
                                        <span
                                            className={`cursor-pointer text-red-500`}
                                            onClick={() => { handleToggleFavorite(result._id, isFavorite) }}

                                        >
                                            <i className={isFavorite ? "fas fa-heart" : "far fa-heart"}></i>
                                        </span>
                                    </div>

                                    <p class="text-sm text-black-700">
                                        Among shoppers who bought{" "}
                                        <b>
                                            {result.antecedentSkus.join(",")}
                                        </b>{" "}
                                        Out of those&nbsp;
                                        {formatConfidence(
                                            result.confidence
                                        )}
                                        %  also bought{" "}
                                        <span class="font-semibold">
                                            {result.consequentSkus.join("+")}{" "}

                                        </span>
                                    </p>
                                </div>

                                {/* Metrics */}
                                <div className="text-center text-sm text-black-700 px-6 pt-4">
                                    <span className="inline-block mx-2 underline cursor-pointer"
                                        onClick={() => {
                                            handleView(
                                              result?.antecedentSkus,
                                              result?.consequentSkus,
                                              result?.allSkus,
                                              true
                                            );
                                            setIsBoth({
                                              antecedent: false,
                                              consequent: false,
                                              all: true,
                                            });
                                            setProductList(result);
                                          }}
                                    >👥 <span className="font-medium text-[#5E7BAA] ">{result.totalPurchasedTogether}</span> joint orders</span>
                                    <span className="inline-block mx-2 underline cursor-pointer"
                                    onClick={() => {
                                        handleView(
                                          result?.antecedentSkus,
                                          result?.consequentSkus,
                                          result?.allSkus,
                                          true
                                        );
                                        setIsBoth({
                                          antecedent: false,
                                          consequent: false,
                                          all: true,
                                        });
                                        setProductList(result);
                                      }}
                                    >🛒 <span className="font-medium text-[#5E7BAA] ">{
                                        result?.together_customer_count
                                    }</span> unique customers</span>
                                    <span className="inline-block mx-2"><i className="fas fa-chart-pie text-xs mr-1 text-[#5E7BAA]"></i>Support <span className="font-medium text-[#5E7BAA]">{formatSupport(result.support)}%</span></span>
                                    <span className="inline-block mx-2"><i className="fas fa-bullseye text-xs mr-1 text-[#5E7BAA]"></i>Confidence <span className="font-medium text-[#5E7BAA]">{formatConfidence(
                                        result.confidence
                                    )}%</span></span>
                                    <span className="inline-block mx-2"><i className="fas fa-level-up-alt text-xs mr-1 text-[#5E7BAA]"></i>Lift <span className="font-medium text-[#5E7BAA]">{formatLift(result.lift)}</span></span>
                                </div>

                                <div className="border-t border-[#E5EAF1] my-4"></div>

                                {/* IF and THEN Sections */}
                                <div className="relative md:grid md:grid-cols-[1fr_auto_1fr] gap-8 px-6 py-4">
                                    {/* IF Section */}
                                    <div class="flex flex-col justify-between">
                                        <div className="block w-full">
                                            <h3 className="text-xs uppercase text-black-600 font-semibold mb-3">IF Customer Buys</h3>
                                            {result.antecedents.map(
                                                (data) => {
                                                    let isFavorite = true
                                                    return (
                                                        <div class="flex gap-3 mb-4">
                                                            <div class="w-16 h-16 rounded-md bg-[#EDF1F5] flex items-center justify-center text-black-400">
                                                                <img
                                                                    src={
                                                                        data.image
                                                                            ? data.image
                                                                            : "noimage.jpg"
                                                                    }
                                                                    class="h-12 w-12"
                                                                />
                                                            </div>
                                                            <div>
                                                                <p class="font-medium leading-snug text-black-800">
                                                                    {data.product_title}
                                                                </p>
                                                                <div className="flex items-center justify-left gap-2">
                                                                    <p
                                                                        className="text-xs text-black-500 cursor-pointer underline"
                                                                    onClick={() => {
                                                                    dispatch(setAntecedentInfo(data));
                                                                    navigate(`/product`, {
                                                                        state: {
                                                                        order_details_id: order_details_id,
                                                                        isSingleOrderExclude: currentAnalysisData.isExclude,
                                                                        },
                                                                    });
                                                                    }}
                                                                    >
                                                                        {[
                                                                            data.sku,
                                                                            data.color,
                                                                            data.selling_price && `$${data.selling_price}`,
                                                                        ]
                                                                            .filter(Boolean)
                                                                            .join(" | ")}
                                                                    </p>

                                                                    {/* <span
                                                                        className={`cursor-pointer text-red-500`}
                                                                    // onClick={()=>{handleToggleSKUFavorite(data,isFavorite)}}
                                                                    >
                                                                        <i className={isFavorite ? "fas fa-heart" : "far fa-heart"}></i>
                                                                    </span> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>


                                        <div className="bg-[#F4F6FA] p-3 rounded-md mt-4 text-sm">
                                            <div className="flex justify-between mb-1">
                                                <span className="text-black-600">Orders with IF Items:</span>
                                                <span className="font-medium text-[#5E7BAA] cursor-pointer underline"
                                                onClick={() => {
                                                    handleView(
                                                      result?.antecedentSkus,
                                                      result?.consequentSkus,
                                                      result?.allSkus,
                                                      true
                                                    );
                                                    setIsBoth({
                                                      antecedent: true,
                                                      consequent: false,
                                                      all: false,
                                                    });
                                                    setProductList(result);
                                                  }}
                                                >
                                                    {
                                                        result.antecedentPurchasedTogether
                                                    } orders | {
                                                        result?.antecedent_customer_count
                                                    } customers
                                                </span>
                                            </div>
                                            <div className="flex justify-between">
                                                <span className="text-black-600">Support:</span>
                                                <span className="font-medium text-[#5E7BAA]"> {formatSupport(
                                                    result.antecedent_support
                                                )}%</span>
                                            </div>
                                        </div>
                                    </div>


                                    {/* Center arrow/line */}
                                    <div className="hidden md:flex items-center justify-center">
                                        <div className="w-auto my-6 self-center">
                                            <div className="product-combo w-16 mx-auto border-t border-gray-300"></div>
                                        </div>
                                    </div>

                                    {/* THEN Section */}
                                    <div>
                                        <h3 className="text-xs uppercase text-black-600 font-semibold mb-3">THEN Customer Also Buys</h3>
                                        {result.consequent.map((data) => {
                                            let isFavorite = true
                                            return (
                                                <div class="flex gap-3 mb-4">
                                                    <div class="w-16 h-16 rounded-md bg-[#EDF1F5] flex items-center justify-center text-black-400">
                                                        <img
                                                            src={
                                                                data.image
                                                                    ? data.image
                                                                    : "noimage.jpg"
                                                            }
                                                            class="h-12 w-12"
                                                        />
                                                    </div>
                                                    <div>
                                                        <p class="font-medium leading-snug text-black-800">
                                                            {data.product_title}
                                                        </p>
                                                        <div className="flex items-center justify-left gap-2">
                                                            <p
                                                                className="text-xs text-black-500 cursor-pointer underline"
                                                            onClick={() => {
                                                            dispatch(setAntecedentInfo(data));
                                                            setIsClickOnSku(true)
                                                            dispatch(setIsProductPage(true))
                                                            // navigate(`/product`, {
                                                            //     state: {
                                                            //     order_details_id: order_details_id,
                                                            //     isSingleOrderExclude: currentAnalysisData.isExclude,
                                                            //     },
                                                            // });
                                                            }}
                                                            >
                                                                {[
                                                                    data.sku,
                                                                    data.color,
                                                                    data.selling_price && `$${data.selling_price}`,
                                                                ]
                                                                    .filter(Boolean)
                                                                    .join(" | ")}
                                                            </p>

                                                            {/* <span
                                                                className={`cursor-pointer text-red-500`}
                                                            // onClick={()=>{handleToggleSKUFavorite(data,isFavorite)}}
                                                            >
                                                                <i className={isFavorite ? "fas fa-heart" : "far fa-heart"}></i>
                                                            </span> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}

                                        <div className="bg-[#F4F6FA] p-3 rounded-md mt-4 text-sm">
                                            <div className="flex justify-between mb-1">
                                                <span className="text-black-600">Orders with THEN Items:</span>
                                                <span className="font-medium text-[#5E7BAA] cursor-pointer underline"
                                                onClick={() => {
                                                    handleView(
                                                      result?.antecedentSkus,
                                                      result?.consequentSkus,
                                                      result?.allSkus,
                                                      true
                                                    );
                                                    setIsBoth({
                                                      antecedent: false,
                                                      consequent: true,
                                                      all: false,
                                                    });
                                                    setProductList(result);
                                                  }}
                                                
                                                >
                                                    {
                                                        result.consequnetPurchasedTogether
                                                    } orders | {
                                                        result?.consequent_customer_count
                                                    } customers
                                                </span>
                                            </div>
                                            <div className="flex justify-between">
                                                <span className="text-black-600">Support:</span>
                                                <span className="font-medium text-[#5E7BAA]">{formatSupport(
                                                    result.consequent_support
                                                )}%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    })
                }
                {
                    favoriteCombinationsResponse.length === 0 && (
                        <div className="text-center text-gray-500 py-10">No favorite Combination found.</div>
                    )
                }

                {isModalOpen && order_details_id && (
                        <CustomerPopupWithOrder
                            isOpen={isModalOpen}
                            onClose={() => setModalOpen(false)}
                            title="Popup Title"
                            order_details_id={order_details_id}
                            sku={sku}
                            isBoth={isBoth}
                            isSingleExclude={currentAnalysisData.isExclude}
                            productList={productList}
                        />
                )}

                {   
                isClickOnSku &&
                <ProductPage 
                    setIsClickOnSku={setIsClickOnSku}
                    isSubComponent={true}
                    supportFilter={supportFilter}
                    selectedCombo={selectedCombo}
                    setCountItemSet={setCountItemSet}
                    
                
                />
                }
            </div>
        </>
    )
}

export default FavoriteCombinations;